import { IResource } from 'interfaces/resources';
import { generateResources } from 'utils/GenerateResouces';

const resource: IResource = {
  name: 'complementary_activities',
  label: 'Atividades acadêmicas complementares (AAC)',
  actions: ['list', 'show', 'create', 'edit', 'approve', 'reject', 'delete'],
  parentName: 'students_teachers',
  onlyPermission: true
};

export default generateResources(resource);
